<div class="visit-table-cell-text" (dblclick)="onEdit()" [class.editing]="editing" [class.editable]="editable"
  [ngStyle]="{ 'min-width': minWidth ? minWidth : '', 'max-width': maxWidth  ? maxWidth : ''}">
  <span class="cell__full" *ngIf="!editing"><span *ngIf="negativeAmount">-</span>{{ renderedValue }}</span>

  <span *ngIf="editing && editable" class="editing" [formGroup]="parentForm">
    <input #input type="number" [formControlName]="controlName" (blur)="onBlur()" (keyup.enter)="onBlur()" />
  </span>
</div>